module.exports = __webpack_public_path__ + "26790dcdb56da3868ccaae2649fe16ce.otf";